import { useGetAnalysisByInvestmentCaseId } from "Infrastructure/ApiZfp/AnalyzerApi";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import { Navigate, useParams } from "react-router-dom";

export const NsureInvestmentCallbackPage: React.FunctionComponent = () => {
  const { caseId } = useParams<{ caseId: string }>();

  const { data, isError } = useGetAnalysisByInvestmentCaseId(caseId ?? "", {
    query: { enabled: !!caseId },
  });

  if (isError || !caseId) {
    return <Navigate to={AppRouting.Dashboard.path()} replace />;
  }

  if (!data) {
    return null;
  }

  return <Navigate to={`${AppRouting.AnalysisDetail.path(data.analysisId, data.versionId)}?tab=goal-fulfillment`} replace />;
};
